import React from 'react';
import { TRANSFER_TAB, TRANSFER_TOOLTIPS } from '../constants';
import {
  TransferSection,
  TransferLabel,
  AgentItem,
  AgentAvatar,
  AgentInfo,
  AgentName,
  AgentSpecialty,
  StatusDot,
  OfflineAvatar,
  TeamItem,
  TeamAvatar,
  TeamInfo,
  TeamName,
  TeamMeta,
} from '../styled-comps';

// ── Helpers ────────────────────────────────────────────────────────────────
export const getInitials = entity =>
  entity.initials || (entity.name || '').slice(0, 2).toUpperCase();

export const getSpecialty = agent => {
  if (agent.specialty) return agent.specialty;
  const count = agent.open_ticket_count || agent.open_count || 0;
  return `${count} open ticket${count !== 1 ? 's' : ''}`;
};

// ── Agent list (online / offline) ──────────────────────────────────────────
export const AgentListSection = ({ label, agents, isOnline, selectedId, onSelect }) => (
  <TransferSection>
    <TransferLabel>
      {label} ({agents.length})
    </TransferLabel>
    {agents.map(agent => {
      const Avatar = isOnline ? AgentAvatar : OfflineAvatar;
      return (
        <AgentItem
          key={agent.id}
          $selected={selectedId === agent.id}
          onClick={() => onSelect(agent)}
        >
          <Avatar>{getInitials(agent)}</Avatar>
          <AgentInfo>
            <AgentName>{agent.name}</AgentName>
            <AgentSpecialty>{getSpecialty(agent)}</AgentSpecialty>
          </AgentInfo>
          <StatusDot $online={isOnline} />
        </AgentItem>
      );
    })}
  </TransferSection>
);

// ── Team list ──────────────────────────────────────────────────────────────
export const TeamListSection = ({ teams, currentTeamId, selectedId, onSelect }) => (
  <TransferSection>
    <TransferLabel>
      {TRANSFER_TAB.TEAMS.label} ({teams.length})
    </TransferLabel>
    {teams.map(team => {
      const total = team.total_member_count ?? 0;
      const online = team.online_member_count ?? 0;
      const isCurrentTeam = currentTeamId === team.id;
      const disabled = total === 0 || isCurrentTeam;
      const tooltip = isCurrentTeam
        ? TRANSFER_TOOLTIPS.ALREADY_ON_TEAM
        : total === 0
        ? TRANSFER_TOOLTIPS.NO_AGENTS
        : '';
      return (
        <TeamItem
          key={team.id}
          $selected={selectedId === team.id}
          $disabled={disabled}
          title={tooltip}
          onClick={() => {
            if (!disabled) onSelect(team);
          }}
        >
          <TeamAvatar>{getInitials(team)}</TeamAvatar>
          <TeamInfo>
            <TeamName>{team.name}</TeamName>
            <TeamMeta>
              {online} online / {total} total
            </TeamMeta>
          </TeamInfo>
        </TeamItem>
      );
    })}
  </TransferSection>
);
